/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_PageInputs */

const en_whats_new_page = /** @type {(inputs: Whats_New_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's new`)
};

const de_whats_new_page = /** @type {(inputs: Whats_New_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist neu`)
};

/**
* | output |
* | --- |
* | "What's new" |
*
* @param {Whats_New_PageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_page = /** @type {((inputs?: Whats_New_PageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_PageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_whats_new_page(inputs)
	return en_whats_new_page(inputs)
});